(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-related/assets/react/components/select-charity-header.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-related/assets/react/components/select-charity-header.js');

'use strict';

var _svs$lyckoplatsen$dat;
const relatedChooseVGHO = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data.cms) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.relatedChooseVGHO;
const CmsTextFormatter = svs.lyckoplatsen.shared_utils.react.components.CmsTextFormatter;
const activeCharitiesAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.activeCharitiesAtom;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const NO_CHARITY_TEXT = svs.lyckoplatsen.components.shared_constants.CONSTANTS.NO_CHARITY_TEXT;
const SelectCharityHeader = () => {
  const activeCharities = useAtomValue(activeCharitiesAtom);
  if (!(activeCharities !== null && activeCharities !== void 0 && activeCharities.length)) {
    return React.createElement("div", null, React.createElement("p", {
      className: "f-800 margin-bottom-2 align-center line-height-1"
    }, NO_CHARITY_TEXT.title), React.createElement("p", {
      className: "align-left"
    }, NO_CHARITY_TEXT.description));
  }
  return React.createElement("div", {
    className: "".concat(relatedChooseVGHO === null || relatedChooseVGHO === void 0 ? void 0 : relatedChooseVGHO.color)
  }, React.createElement("p", {
    className: "f-800 margin-bottom-2 align-center line-height-1"
  }, relatedChooseVGHO === null || relatedChooseVGHO === void 0 ? void 0 : relatedChooseVGHO.textTitle), React.createElement("p", {
    className: "align-left"
  }, React.createElement(CmsTextFormatter, {
    text: relatedChooseVGHO === null || relatedChooseVGHO === void 0 ? void 0 : relatedChooseVGHO.textDescription
  })));
};
setGlobal('svs.lyckoplatsen.components.page_related.react.components', {
  SelectCharityHeader
});

 })(window);